module.exports = __webpack_public_path__ + "img/asian-noodle-soup-1.20f2613c.jpg";